import { Col, Row } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import "./../../../assets/style/pageStyle/spamManagement.scss";
import { IconPlus } from "../../../assets/icon";
import BaseButton from "../Button/BaseButton";
import TblListSpam from "../Table/TblListSpam";
import ModalAddSpamFile from "../Modal/add/ModalAddSpamFile";
import SelectValue from "../Selector/SelectValue";
import {
  getListFileSpam,
  setOpenModalGetLogSpam,
} from "../../../services/slice/SpamSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { spamSelector } from "../../../services/selector/index.";
import ModalGetLog from "../Modal/getLog/ModalGetLog";
const ListSpam = () => {
  const { t } = useTranslation();
  const [isOpenAdd, setIsOpenAdd] = useState(false);
  const spamState = useSelector(spamSelector);
  const [config, setConfig] = useState({
    typeSearch: "-1",
    option: {
      limit: 10,
      offset: 1,
      order: "asc",
    },
  });
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getListFileSpam(config));
  }, [config, dispatch]);

  const valueOptionsRole = useMemo(() => {
    const result = [
      {
        value: -1,
        label: "Tất cả",
      },
    ];

    if (spamState.listTypeSpam?.length) {
      spamState.listTypeSpam.map((item) => {
        return result.push({
          value: item.type,
          label: item.typeName,
        });
      });
    }
    return result;
  }, [spamState.listTypeSpam]);

  return (
    <div>
      {spamState.isOpenModalGetLog && (
        <ModalGetLog
          open={spamState.isOpenModalGetLog}
          setOpen={setOpenModalGetLogSpam}
          data={spamState.dataLogSpam}
        />
      )}
      {isOpenAdd ? (
        <ModalAddSpamFile width={680} open={isOpenAdd} setOpen={setIsOpenAdd} />
      ) : null}
      <div className="headerPage">
        <h2 className="title">{t("Danh sách file data spam")}</h2>
      </div>
      <Row style={{ width: "100%" }} justify={"space-between"}>
        <Col className="mr-5">
          <span className="mr-5">Loại file</span>
          <SelectValue
            type={"selectGray"}
            optionsValue={valueOptionsRole}
            width={170}
            defaultValue={"Tất cả"}
            handleChange={(value) => {
              setConfig({
                ...config,
                typeSearch: value,
              });
            }}
            key="selectFileSpam"
          />
        </Col>
        <Col style={{ flexGrow: 1, display: "flex", justifyContent: "end" }}>
          <BaseButton
            icon={
              <IconPlus
                width={16}
                height={14}
                style={{ marginRight: "0.5rem" }}
              />
            }
            handleClick={() => setIsOpenAdd(true)}
            content={`Thêm mới`}
            width={120}
            typeBtn="btnOrange"
          />
        </Col>
      </Row>
      <TblListSpam />
    </div>
  );
};

export default ListSpam;
